import { cn } from "@/lib/utils";

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      {...props}
      aria-hidden="true"
      className={cn(
        className,
        "bg-accent pointer-events-none animate-pulse rounded-md",
      )}
    />
  );
}

function InlineSkeleton({ className, ...props }: React.ComponentProps<"span">) {
  return (
    <span
      data-slot="skeleton"
      {...props}
      aria-hidden="true"
      className={cn(
        className,
        "bg-accent pointer-events-none inline-block animate-pulse rounded-md",
      )}
    />
  );
}

export { InlineSkeleton, Skeleton };
